import React from 'react';
import { CashflowCalculateData } from './bonds.types';

const formatPrice = (value?: string | number | null) => {
  if (value === null || value === undefined || value === '') return '₹0';
  return value;
};

const formatSettlementDate = (value?: string | null) => {
  if (!value) return '-';
  const d = new Date(value);
  if (isNaN(d.getTime())) return '-';
  return d.toLocaleDateString('en-IN', { day: '2-digit', month: '2-digit', year: 'numeric' });
};

const Row = ({ label, value }: { label: string; value: React.ReactNode }) => (
  <div className="flex items-center justify-between">
    <span className="text-sm text-stone-500">{label}</span>
    <span className="text-sm font-medium text-[#23272F]">{value}</span>
  </div>
);

function PriceBreakdown({ calc }: { calc: CashflowCalculateData | null }) {
  if (!calc) return null;

  return (
    <div className="bg-white rounded-xl px-5 py-4 flex flex-col gap-4 w-64">
      <Row label="Clean price" value={`₹${formatPrice(calc.cleanPrice)}`} />
      <Row label="Dirty price" value={`₹${formatPrice(calc.dirtyPrice)}`} />
      <Row label="Accrued interest" value={`₹${formatPrice(calc.accruedInterest)}`} />
      <Row label="Stamp duty" value={`₹${formatPrice(calc.stampDuty)}`} />
      <Row label="Settlement date" value={formatSettlementDate(calc.settlementDate)} />
    </div>
  );
}

export default PriceBreakdown;
